"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SortAZSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M3,13 L2,13 L5.0350669,5.32883269 C5.2229467,4.8797533 5.8222655,4.92881858 5.9649331,5.32883269 L9,13 L7.96079259,12.9982727 L7.16148352,11 L3.81251814,11 L3,13 Z M4.2187772,10 L6.76148352,10 L5.5,6.8462912 L4.2187772,10 Z M15.8507514,12.1476371 C16.0391995,12.3415487 16.0375633,12.6506837 15.8470732,12.8425896 L13.5,15.2071068 L11.1628682,12.8771355 C10.9695113,12.6843711 10.9687199,12.3714546 11.1610993,12.1777146 C11.3536437,11.9838083 11.6666823,11.9819334 11.8615356,12.1735193 L13,13.2928932 L13,4 L14,4 L14,13.2928932 L15.1649964,12.1408249 C15.3546017,11.9533237 15.6603068,11.9550294 15.847808,12.1446346 L15.8507514,12.1476371 Z" })));
};
SortAZSmall.displayName = 'SortAZSmall';
exports.default = SortAZSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SortAZSmall.js.map